export default "__VITE_ASSET__DTelOjY8__"